module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAVCAYAAADl/ahuAAABVUlEQVRYheXXOUvFQBSG4ce4IaIgdv4DBcXCfQO1sPD3CjbuorgUggiWVlaKoKi4W+RGk9zYDoN5IUyY03y8zDmTtNwODatgHStVhZpxlVRsdmAudJJI2awSNIFuXKClps9aw8VWlaClzF6l0/9PGxYa75UnqO6CxtGDS1yXBXVhCh/YCRwsFhYb6xaUBc2iE2e4CxgqJgodVBaU2dsIFicuOjGDT2zTLCiztx0sUlxMS8fMOW4oCurFGN6wGzxaHDRdUHlB89Ir7hiPAUPFRGFAUxS0VC7WjG5MKt3gVYLqOqDn0Y5T3GebmaB+jOAZh8GjxUHWXoUP5CRXTHCAl4ChYmK5sRZGTF4Q9f296MOo9HDs5wtlQXUd0AtoxZF0zPyQYACDeMBJ8GhxkLVX0wWV+D09u3gPlSgy/uygtlxxFV+hEkXIk7TFCiR+j1fd2cNrefMbvuw7YGeYEbwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/btn-hide-bg--hover.png
// module id = 800
// module chunks = 0